export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Регистрационные сведения"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сохранить данные"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтверждено"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Это поле общедоступно и видно другим пользователям"])},
  "5": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Это поле скрыто от других пользователей"])},
  "6": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Верификация личности"])},
  "7": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Подтверждена"])},
  "8": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["В процессе"])},
  "9": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Не пройдена"])},
  "10": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Начать верификацию"])}
}